import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
// import TractorBooking from "../components/views/TractorBooking";
// import Overview from "../components/views/Overview";
// import Trips from "../components/views/Trips";
import Sidebar from "../components/Sidebar";
// import Header from "../components/Header";
// import AggregateBooking from "../components/views/AggregateBooking";
// import FiveMBooking from "../components/views/FiveMBooking";
// import ContainerReport from "../components/views/ContainerReport";
// import DailyPlanEmailWindow from "../email-template/dailyPlanEmailWindow";
// import TransporterData from "../components/views/TransporterData";
// import ContainerMasterData from "../components/views/ContainerMasterData";
// import ArrivalDepartureReport from "../components/views/ArrivalReport";
// import VGMData from "../components/views/VGMData";
// import InvoicePackingEmailWindow from "../email-template/invoicePackingEmailWindow";
// import VGMEmailWindow from "../email-template/VGMEmailWindow";
// import DepartureReport from "../components/views/DepartureReport";
import * as actionType from "../store/ActionTypes";
import { dispatcher } from "../store/storeHelpers";
import { getUserAccessDataService,GetMailRecepients} from "../services/dataService";
import { getUser } from "../services/authService";
import { routeMapping } from "../services/routeManager";
import { filter } from "lodash";
import NotAllowed from "../pages/NotAllowed";
import { initializeRecepients } from "../services/emailService";


const Dashboard = () => {
	const [pinned, setPinned] = useState(false);
	// const [activateSidebar, setActivateSidebar] = useState(false);
	const pinnedMainTag = pinned ? "pinnedMainClass" : "mainClass";
	const [userData, setUserData] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const user = getUser();
		async function getUserAccessData() {
			setLoading(true);
			const response = await getUserAccessDataService({
				userId: user.uid,
				Appname: "Aryabhatta",
			});
			setLoading(false);
			setUserData(response.data);
			dispatcher(actionType.LOAD_USER_ACCESS, response.data);
		}
		getUserAccessData();
		async function getEmailRecipents(){
			const response = await GetMailRecepients()
			dispatcher(actionType.EMAIL_RECEPIENTS, response.data);
			initializeRecepients();
		}
		getEmailRecipents()
	}, []);

	return (
		<>
			<Sidebar pinned={pinned} setPinned={setPinned} />
			{/* {activateSidebar && (
        <SidebarResponsive
          show={activateSidebar}
          onHide={() => setActivateSidebar(false)}
          setActivateSidebar={setActivateSidebar}
        />
      )} */}
			<main className={pinnedMainTag}>
				{/* <i
          className="bx bx-menu sidebarMenuBtn"
          style={{
            transform: "scale(2.5)",
            // zIndex: "9999999",
            position: "relative",
            left: "-20px",
            top: "58px",
            cursor: "pointer",
          }}
          onClick={() => setActivateSidebar(true)}
        ></i> */}
				{/* <Header /> */}
				{userData.length > 0 &&
					routeMapping.map((routeInfo) => {
						if (
							filter(userData, {
								MenuName: routeInfo.SubMenuName,
								View: 1,
							}).length !== 0
						) {
							return (
								<Route
									exact
									path={routeInfo.pathName}
									component={routeInfo.component}
								/>
							);
						}
						if (
							filter(userData, {
								MenuName: routeInfo.SubMenuName,
								View: 1,
							}).length === 0
						) {
							if (
								!loading &&
								filter(userData, { MenuName: routeInfo.SubMenuName, View: 1 })
									.length === 0
							) {
								return (
									<Route
										exact
										path={`${routeInfo.pathName}`}
										component={NotAllowed}
									/>
								);
							}
						}
					})}
				{/* <Route exact path="/dashboard/overview" component={Overview} />
        <Route exact path="/dashboard/trips" component={Trips} />
        <Route
          exact
          path="/dashboard/booking/tractor"
          component={TractorBooking}
        />
        <Route
          exact
          path="/dashboard/booking/aggregate"
          component={AggregateBooking}
        />
        <Route exact path="/dashboard/booking/fiveM" component={FiveMBooking} />
        <Route
          exact
          path="/dashboard/transporter"
          component={TransporterData}
        />
        <Route exact path="/dashboard/VGM" component={VGMData} />
        <Route
          exact
          path="/dashboard/container-master"
          component={ContainerMasterData}
        />
        <Route
          exact
          path="/dashboard/container-report"
          component={ContainerReport}
        />
        <Route
          exact
          path="/dashboard/arrival-report"
          component={ArrivalDepartureReport}
        />
        <Route
          exact
          path="/dashboard/departure-report"
          component={DepartureReport}
        />
        <Route
          exact
          path="/dashboard/daily-plan-email"
          component={DailyPlanEmailWindow}
        />
        <Route
          exact
          path="/dashboard/invoice-packing-email"
          component={InvoicePackingEmailWindow}
        />
        <Route exact path="/dashboard/VGM-email" component={VGMEmailWindow} /> */}
			</main>
		</>
	);
};

export default Dashboard;
